"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const draft_js_1 = require("draft-js");
const link_style_1 = __importDefault(require("./link.style"));
const Link = ({ classes, entityKey, children }) => {
    const { url } = draft_js_1.Entity.get(entityKey).getData();
    return (jsx_runtime_1.jsx("a", Object.assign({ className: classes.root, href: url, rel: "noopener noreferrer", target: "_blank", "aria-label": url }, { children: children }), void 0));
};
exports.Link = Link;
exports.Link.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    entityKey: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node
};
exports.Link.defaultProps = {
    children: null
};
exports.default = react_jss_1.default(link_style_1.default)(exports.Link);
//# sourceMappingURL=index.js.map